export default [
  // - Cleaning weekly planning
  {
    path: "/planning",
    name: "foravila-cleaning-planning",
    component: () => import("@/views/cleaning/planning/CleaningPlanning.vue"),
    meta: {
      pageTitle: "Planning",
      breadcrumb: [{ text: "Planning", active: true }],
    },
  },
];
